export type PublicationLightType = {
  slug: string;
  browserTitle: string | null;
  url: string;
  onlineAt: string;
};

type SpreadType = {
  pages: string[];
};

export type PublicationDetailedType = {
  config: {
    publicationId: number;
    slug: string;
    publicationTitle: string;
  };
  spreads: SpreadType[];
};

type CategoryType = "winterkataloge" | "sommerkataloge" | "magazine";
type IsOfCategoryFunctionType = (title: string) => boolean;

type CategorizationDataType = {
  anchorId: CategoryType;
  catalogues: PublicationDetailedType[];
  receivesCatalogueWithTitle: IsOfCategoryFunctionType;
};

// hardcoded categorization stub data, including initially
// empty catalogues array and helper boolean function
const CategorizationStubData: CategorizationDataType[] = [
  {
    anchorId: "winterkataloge",
    catalogues: [],
    receivesCatalogueWithTitle: (title) => (title.includes("winter") && title.includes("katalog")) || title.includes("weihnachtsmagazin"),
  },
  {
    anchorId: "sommerkataloge",
    catalogues: [],
    receivesCatalogueWithTitle: (title) => title.includes("sommer") && title.includes("katalog"),
  },
  {
    anchorId: "magazine",
    catalogues: [],
    receivesCatalogueWithTitle: (title) => !title.includes("weihnachtsmagazin") && !title.includes("katalog"),
  },
];

// Order of categories based on links from the header link list maintenanced in the TextLong.
export const getOrderedCatalogueCategories = (catalogues: PublicationDetailedType[]): CategorizationDataType[] => {
  // header link list from TextLong
  const catalogueLinklist = document.body.querySelectorAll<HTMLAnchorElement>(".katalog-linkliste a");
  let orderedAnchorList: CategoryType[];

  // if list present, take the order of this list as reference
  if (catalogueLinklist.length) {
    orderedAnchorList = Array.from(catalogueLinklist).map((anchor) => anchor.href.split("#")[1] as CategoryType);
  } else {
    // Get month for season retrieval
    const month = new Date().getMonth() + 1;

    // Default fallback order, depending on the summer/winter season
    orderedAnchorList =
      3 <= month && month < 10
        ? ["sommerkataloge", "winterkataloge", "magazine"]
        : ["winterkataloge", "sommerkataloge", "magazine"];
  }

  // Array containing the categories in order, including enriched catalogues array
  const orderedCategoryList: CategorizationDataType[] = [];
  orderedAnchorList.forEach((anchor) => {
    const tempCategory = CategorizationStubData.find((stubCategory) => stubCategory.anchorId === anchor);
    if (tempCategory) {
      // Filter catalogues of category type and set into stub tempCategory
      tempCategory.catalogues = catalogues.filter<PublicationDetailedType>(generateFilterFunction(tempCategory));
      // Add the decorated category to the list array
      orderedCategoryList.push(tempCategory);
    }
  });

  return orderedCategoryList;
};

// returns the filter callback function to retrieve dedicated catalogues for certain categories
const generateFilterFunction = (category: CategorizationDataType) => {
  return (catalog: PublicationDetailedType): catalog is PublicationDetailedType => {
    // title toLowerCase
    const titleOfCatalogue = catalog.config.publicationTitle.toLowerCase();

    // Add catalogue if title matches certain category constraints. see CategorizationStubData
    return category.receivesCatalogueWithTitle(titleOfCatalogue);
  };
};

export const sortByActivationDate = (a: PublicationLightType, b: PublicationLightType): -1 | 0 | 1 => {
  if (a.onlineAt < b.onlineAt) {
    return 1;
  } else if (a.onlineAt === b.onlineAt) {
    return 0;
  } else {
    return -1;
  }
};
